import { NamedProperty, SprintQueryResult, useSprintQuery } from "sprint-common-web";

import { useCatalogueLookupsApi } from "../../api/catalogue-api/lookups/useCatalogueLookupsApi";
import { sortVersionTypesByName } from "../../utils/sortVersionTypesByName";
import { DataHooksQueryKey } from "./DataHooksQueryKey";

export const useNonTrailerVersionTypes = (): SprintQueryResult<NamedProperty[]> => {
    const { getNonTrailerVersionTypes } = useCatalogueLookupsApi();

    return useSprintQuery<NamedProperty[]>({
        queryKey: [DataHooksQueryKey.NonTrailerVersionTypes],
        queryFn: async (): Promise<NamedProperty[]> => {
            const response = await getNonTrailerVersionTypes();
            return sortVersionTypesByName(response.versions);
        }
    });
};
